import base64Conversion from './base64conversion';

export default function getStudentDetentions(schoolCode, studentNo, studentId) {
  const header = base64Conversion();
  return fetch(`${process.env.REACT_APP_API_HEAD}/getStudentTardiesAndDetentionsDetails/detention`, {
    method: 'POST',
    body: JSON.stringify({
      school_code: schoolCode,
      student_no: studentNo,
      student_id: studentId,
    }),
    headers: {
      'content-type': 'application/json',
      Authorization: header,
    },
  })
    .then((res) => res.json());
}
